<template>
  <div class="d-block" style="width: 100%; height: 180px;">
    <div class="d-flex justify-space-between align-center px-5">
      <div>
        <v-hover
          v-if="btnPrevVisible"
          v-slot="{ hover }"
        >
          <v-icon
            :disabled="btnPrevDisabled"
            color="#F7D091"
            size="47"
            class="navigation__icon-prev"
            @click="onBtnPrevClicked"
          >
            {{ hover ? '$prevStageHover' : '$prevStage' }}
          </v-icon>
        </v-hover>
      </div>
      <div>
        <!-- Отдельная проверка computedBtnNextColor сделана для этапа PatientDataStep:
        там кнопка остаётся кликабельной (disabled = false), но с неактивным цветом. -->
        <v-hover
          v-slot="{ hover }"
          :disabled="btnNextDisabled || computedBtnNextColor === '#F7D091'"
        >
          <v-icon
            :disabled="btnNextDisabled"
            :color="computedBtnNextColor"
            size="85"
            class="navigation__icon-next"
            @click="onBtnNextClicked"
          >
            {{ hover ? '$nextStageHover' : '$nextStage' }}
          </v-icon>
        </v-hover>
      </div>
    </div>
  </div>
</template>

<script>
import {isNullOrUndefined} from '@/plugins/object-helpers'

export default {
  props: {
    onBtnPrevClicked: Function,
    onBtnNextClicked: Function,
    btnPrevDisabled: Boolean,
    btnPrevVisible: {
      type: Boolean,
      default: true
    },
    btnNextDisabled: Boolean,
    btnNextColor: {
      type: String,
      default: null
    }
  },
  computed: {
    computedBtnNextColor() {
      if (!isNullOrUndefined(this.btnNextColor)) {
        return this.btnNextColor
      }
      if (this.btnNextDisabled) {
        return '#F7D091'
      }
      return '#F39F18'
    }
  }
}
</script>

<style scoped>

</style>